import React from "react"
import { getImage } from "gatsby-plugin-image"
import { StaticQuery, graphql } from "gatsby"

const Image = ({ path, render }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          images: allFile {
            nodes {
              absolutePath
              childImageSharp {
                gatsbyImageData(
                  width: 1920
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      `}
      render={data => {
        const image = data.images.nodes.find(
          image => image.absolutePath === path
        )
        const imagePhoto = getImage(image)
        return render(imagePhoto)
      }}
    />
  )
}

export default Image
